import type { ContentItem } from "@/types/content";
import { newsList } from "@/mocks/news";
import { worksList } from "@/mocks/works";
import { analysisList } from "@/mocks/analysis";

export const newsItems = newsList as ContentItem[];
export const workItems = worksList as ContentItem[];
export const analysisItems = analysisList as ContentItem[];
export const allContent: ContentItem[] = [...newsItems, ...workItems, ...analysisItems];

export const typeLabels: Record<string, string> = {
  news: "资讯",
  work: "作品",
  analysis: "解析",
};

export function typeLabel(type: string): string {
  return typeLabels[type] || "内容";
}

export function getContentById(id: string): ContentItem | undefined {
  return allContent.find((item) => item.id === id);
}

export function getContentHref(id: string): string {
  return `/detail/${id}`;
}

export function sortByDate(items: ContentItem[]): ContentItem[] {
  return [...items].sort((a, b) => (a.date < b.date ? 1 : -1));
}

export function sortByPopularity(items: ContentItem[]): ContentItem[] {
  return [...items].sort((a, b) => b.popularity - a.popularity);
}

export function getRelated(item: ContentItem, limit = 10): ContentItem[] {
  const scored = allContent
    .filter((candidate) => candidate.id !== item.id)
    .map((candidate) => {
      const sharedTags = candidate.tags.filter((tag) => item.tags.includes(tag)).length;
      const sameCategory = candidate.category === item.category ? 2 : 0;
      const sameType = candidate.type === item.type ? 1 : 0;
      return { candidate, score: sharedTags * 3 + sameCategory + sameType };
    })
    .filter((entry) => entry.score > 1)
    .sort((a, b) => b.score - a.score || b.candidate.popularity - a.candidate.popularity);
  return scored.slice(0, limit).map((entry) => entry.candidate);
}

export interface SearchOptions {
  type?: string;
  sort?: string;
}

export function searchContent(keyword: string, options: SearchOptions = {}): ContentItem[] {
  const query = keyword.trim().toLowerCase();
  let results = allContent;
  if (query) {
    results = results.filter((item) => {
      const haystack = [item.title, item.summary, item.category, item.author, item.tags.join(" ")]
        .join(" ")
        .toLowerCase();
      return haystack.includes(query);
    });
  }
  if (options.type && options.type !== "all") {
    results = results.filter((item) => item.type === options.type);
  }
  if (options.sort === "popularity") {
    return sortByPopularity(results);
  }
  return sortByDate(results);
}

export function formatDate(date: string): string {
  return date.replace(/-/g, ".");
}

export function stripHtml(text: string): string {
  return text.replace(/<[^>]+>/g, "");
}